import React from 'react';
import classes from './Burger.css';
import BurgerIngredient from './BurgerIngredients/BurgerIngredient'
const Burger=(props)=>{
    let transformedIngredients=Object.keys(props.ingredients)
        .map(igKey=>{
            let item=[];            
            for(let i=0;i<props.ingredients[igKey];++i)
                 item.push(<BurgerIngredient key={igKey+i} type={igKey} />);                        
            return item;
        })
        .reduce((a,b)=>{            
            return a.concat(b);
        },[]);
    if(transformedIngredients.length===0){
        transformedIngredients=<p>Please start adding ingredients ! </p>;
    }
    return <div className={classes.Burger}>
        <BurgerIngredient type="bread-top" />
        {transformedIngredients}
        <BurgerIngredient type='bread-bottom' />
    </div>
}

export default Burger;